<template>
  <div class="container">
    <div class="search_box">
      <el-form ref="form" class="search_form" :model="searchForm" label-position="left">
        <el-form ref="form" class="search_form" :model="searchForm" label-position="left">
          <el-form-item label="搜索内容" label-width="70px">
            <el-input v-model="tableParams.roleName" placeholder="请输入名称/联系人/电话" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" class="search_area_btn" @click="onSubmit">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-form>
    </div>

    <div class="tree_table">
      <div class="table_box">
        <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
          v-loading="tableLoading">
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column property="roleName" label="手机号">
          </el-table-column>
          <el-table-column property="roleDesc" label="企业名称"> </el-table-column>
          <el-table-column property="roleDesc" label="账户类型"> </el-table-column>
          <el-table-column property="roleDesc" label="备注"> </el-table-column>
          <el-table-column property="createTime" label="创建时间" width="160">
          </el-table-column>
          <el-table-column label="操作" width="170" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="goRedact(scope.row)">审核</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="paging_box">
          <!--  :current-page="currentPage4" -->
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <v-addRedact :show.sync="addRedactShow" :data="redactData" :type="addRedactType"></v-addRedact>
    <v-permission :show.sync="permissionShow" :data="permissionData"></v-permission>
  </div>
</template>

<script>
import addRedact from "./component/addRedactRoleAdmin.vue";
import permission from "./component/permission.vue";
export default {
  name: "",
  data () {
    return {
      searchForm: {},
      tableData: [],
      tableParams: {
        page: 1,
        limit: 10,
        roleName: "", // 角色名称
        status: null, // 状态(0:正常。1：删除)
      },
      total: 0,
      tableLoading: false,
      stateList: [
        {
          label: "启用",
          value: 0,
        },
        {
          label: "禁用",
          value: 1,
        },
      ],
      activeName: "1",
      form: {},
      rules: {},
      defaultProps: {
        children: "children",
        label: "label",
      },
      addRedactShow: false,
      redactData: null,
      addRedactType: 0, // 0 新增  1 编辑
      permissionShow: false,
      permissionData: {},
    };
  },
  components: {
    "v-addRedact": addRedact,
    "v-permission": permission,
  },
  props: {},
  created () {
    this.getList();
  },
  methods: {
    getList () {
      this.tableLoading = true;
      this.$http.queryRoleList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    switchChange (e, val) {
      let params = {
        roleDesc: val.roleDesc,
        roleId: val.roleId,
        roleName: val.roleName,
        status: e,
      };
      this.$http.updateRole(params).then((res) => {
        if (res.code === 0) {
          // this.$message.success(res.msg);
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onSubmit () {
      this.getList();
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    goAdd () {
      this.redactData = null;
      this.addRedactType = 0;
      this.addRedactShow = true;
    },
    goRedact (row) {
      this.redactData = row;
      this.addRedactType = 1;
      this.addRedactShow = true;
    },
    goPermission (row) {
      this.permissionShow = true;
      this.permissionData = row;
    },
    getDetele (row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调接口
          this.$http.deleteRole({ roleIds: row.roleId }).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange (e) {
      console.log(e);
    },
    handleClick (e) {
      console.log("ee", e);
    },
    handleNodeClick (data) {
      console.log("data", data);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/user_Admin/register_Admin.vue